/* eslint-disable no-unreachable */
<template>
  <v-layout column>
    <v-flex>
      <sub-header :subHeaderConfig="subHeaderConfig" />
    </v-flex>
    <v-flex>
      <v-container fluid class="main-content-ctr">
        <div id="subbrandListCnr" class="flex lg12">
          <v-flex lg1>
            <v-spacer></v-spacer>
          </v-flex>
          <!-- Publish popup starts -->
          <v-dialog v-model="dialog" persistent width="450">
            <v-card class="publish-popup">
              <v-card-title class="headline" primary-title>
                <h3 autoid="header-lbl-publish" class="headline">{{ $lang.messages.publish }}</h3>
                <v-spacer></v-spacer>
                <v-btn autoid="close-btn-icon" class="close-btn" depressed @click="dialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text autoid="publish-content-txt">
                <p>
                  Publishing
                  <b class="publish-subbrand-name-text">{{ subrandModal.name }}</b> to
                  <b>{{ updatedOnPublish(subrandModal).buttonText }}</b> environment takes about 5 minutes to
                  become active again. It will be in pending status till the publish
                  activity gets completed.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  outlined
                  @click="showReview(subrandModal)"
                  class="mr-2"
                  autoid="review-details-btn"
                >Review Details</v-btn>
                <v-btn
                  color="primary"
                  depressed
                  :loading="publishLoading"
                  @click="publish(subrandModal)"
                  autoid="publish-btn"
                >Publish to {{ updatedOnPublish(subrandModal).buttonText }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Publish popup starts -->
          <v-dialog v-model="deleteDialog" persistent width="450">
            <v-card class="publish-popup">
              <v-card-title class="headline" primary-title>
                <h3 autoid="header-lbl-publish" class="headline">{{ $lang.messages.delete }}</h3>
                <v-spacer></v-spacer>
                <v-btn autoid="close-btn-icon" class="close-btn" depressed @click="deleteDialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text autoid="publish-content-txt">
                <p>
                  Are you sure you want to delete 
                  <b class="publish-subbrand-name-text">{{ deleteSubrandModal.name }}</b> ?
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  outlined
                  @click="deleteDialog = false"
                  class="mr-2"
                  autoid="review-details-btn"
                >Cancel</v-btn>
                <v-btn
                  color="error"
                  depressed
                  :loading="deleteLoading"
                  @click="deleteSubbrand(deleteSubrandModal)"
                  autoid="publish-btn"
                >Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Search field starts -->
          <v-flex lg10 justify-center>
            <v-text-field
              class="search"
              v-model="search"
              prepend-inner-icon="search"
              label="Search by Sub-brand Name"
              single-line
              outlined
              clearable
              v-on:input="searchCol"
              autoid="txt-bx-search-filter"
            ></v-text-field>

            <!-- Sub-brand table starts -->
            <v-card id="subbrandListTable" class="y-data-table" autoid="list-table">
              <v-data-table
                class="justify-center"
                must-sort
                :headers="headers"
                :items="subBrandListData"
                :search="search"
                :header-props="{
                  sortIcon: 'arrow_drop_down'
                }"
                sort-by="updatedOn"
                sort-desc
                hide-default-footer
                :items-per-page="10"
                :page.sync="page"
                @page-count="pageCount = $event"
                :custom-filter="filterSubbrandName"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="(item, index) in items" :key="index">
                      <td class="subbrand-name-value">
                        <span v-if="item.lastPublishedOn">
                          <a href="javascript:void(0);" @click="loadOverview(item)">
                            <span>{{ item.name }}</span>
                          </a>
                        </span>
                        <span v-else>
                          <span class="subbrand-name">{{ item.name }}</span>
                        </span>
                        <span class="status">
                          ID:
                          <span v-if="item.cobrandId">{{ item.cobrandId }}</span>
                          <span v-else>N/A</span>
                        </span>
                      </td>
                      <td class="text-lg-left">
                        <div class="status-msg">
                          <i :class="[statusMap(item).className, 'dot']"></i>
                          <span>{{ statusMap(item).statusText }}</span>
                        </div>
                      </td>
                      <td class="text-lg-left">{{ updatedOnPublish(item).stateName }}</td>
                      <td class="text-lg-left" v-if="item.lastPublishedOn">
                        <span class="formatDate">{{ item.lastPublishedOn | formatDate }}</span>
                        <span class="time">{{ item.lastPublishedOn | formatDateTime }}</span>
                      </td>
                      <td class="text-lg-left" v-else>N/A</td>
                      <td class="text-lg-left fail-message" v-if="updatedOnPublish(item).message">
                        <span>There was a technical error while publishing to {{ updatedOnPublish(item).buttonText }} environment. Republishing in progress. Check back later.</span>
                        <v-btn
                          color="primary"
                          class="del-btn"
                          autoid="btn-delete-icon"
                          outlined
                          disabled
                        > <v-icon>delete_outline</v-icon> </v-btn>
                      </td>
                      <td v-else class="text-center action-buttons">
                        <v-btn
                          autoid="btn-edit-sub-brand"
                          color="primary"
                          outlined
                          @click="isNewDesignEnabled() ? editSubrandNew(item) : editSubrand(item)"
                          class="edit-btn"
                          :disabled="updatedOnPublish(item).disabled"
                        >Edit</v-btn>
                        <v-btn
                          color="primary"
                          outlined
                          @click="customizeApps(item)"
                          class
                          autoid="btn-customize-apps"
                          :disabled="disableForApi(item) || updatedOnPublish(item).disabled"
                        >Configure Apps</v-btn>
                        <v-btn
                          v-if="item.configStatus && item.configStatus.flowCompleted"
                          color="primary"
                          outlined
                          @click="confirmPublishModal(item)"
                          autoid="btn-publish"
                          :disabled="
                            updatedOnPublish(item).disableProd 
                              ? true : 
                              updatedOnPublish(item).disabled
                          "
                        >Publish to {{ updatedOnPublish(item).buttonText }}</v-btn>
                        <v-btn
                          v-else
                          color="primary"
                          outlined
                          disabled
                          autoid="btn-publish-to-dev"
                        >Publish to Private</v-btn>
                        
                        <v-btn
                          v-if="item.status == 7"
                          color="primary"
                          class="del-btn"
                          autoid="btn-delete-icon"
                          outlined
                          @click="confirmDeleteModal(item)"
                        > <v-icon v-if="item.status == 7">delete_outline</v-icon> </v-btn>
                        <v-btn
                          v-else
                          color="primary"
                          class="del-btn"
                          autoid="btn-delete-icon"
                          outlined
                          disabled
                        > <v-icon>delete_outline</v-icon> </v-btn>
                      </td>
                    </tr>
                    <tr v-if="items.length == 0">
                      <td class="text-lg-center no-result" colspan="5">No Results found</td>
                    </tr>
                    <tr v-if="items.length != 0" class="pagination">
                      <td class="text-lg-right" colspan="5">
                        <v-text-field
                          class="input-pages"
                          outlined
                          min="1"
                          :value="page"
                          type="number"
                          @input="updatePagination($event)"
                          autoid="txt-bx-page-number"
                        ></v-text-field>
                        <div class="page-total">
                          <span>/</span>
                          <span>{{ pageCount }}</span>
                        </div>

                        <v-pagination :value="1" v-model="page" :length="pageCount"></v-pagination>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
          <v-flex lg1>
            <v-spacer></v-spacer>
          </v-flex>
        </div>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import serviceRegistery from '../../mixins/serviceRegistery'
import { helpers } from '../../mixins/helpers'
import { jsonHelper } from '../../mixins/jsonHelper'
import { subbrandToolHelper } from '../../mixins/subbrandToolHelper'
import SubHeader from '../../components/subheader.vue'
import polling from '../../mixins/polling'
export default {
  data() {
    return {
      page: 1,
      pageCount: 0,
      dialog: false,
      search: '',
      publishedIndex: -1,
      // sortBy: 'updatedOn',
      publishLoading: false,
      headers: [
        {
          text: 'Sub-brand Name',
          align: 'start',
          sortable: true,
          value: 'name',
          autoid: 'lbl-sub-brand-name-col-header',
          width: '20%'
        },
        {
          text: 'Deployment Status',
          align: 'start',
          value: 'status',
          sortable: true,
          width: '20%'
        },
        {
          text: 'Environment Status',
          align: 'start',
          value: 'state',
          sortable: true,
          width: '10%'
        },
        { text: 'Last Published', value: 'lastPublishedOn', width: '11%' },
        { text: '', value: '', sortable: false, align: 'center', width: '35%' }
      ],
      subbrands: [],
      subrandModal: {},
      deleteSubrandModal: {},
      deleteDialog: false,
      deleteLoading: false
    }
  },
  mixins: [jsonHelper, subbrandToolHelper, helpers],
  components: {
    'sub-header': SubHeader
  },
  created() {
    // this.getSubrandList()
  },
  mounted: function() {
    polling.startPolling(this.subBrandListData)
  },
  computed: {
    subHeaderConfig() {
      if (this.$enableNewDesign) {
        this.$store.state.appStore.selectedSubbrandInfo = {}
      }
      let config = {
        headerText:
          this.subBrandListData.length === 1
            ? this.$lang.messages.sub_brand
            : this.$lang.messages.sub_brands,
        subBrandCount: this.subBrandListData.length,
        actions: [
          {
            displayName: this.$lang.messages.create_sub_brand,
            autoid: 'create-subbrand-btn',
            controlName: 'button',
            actionType: 'primary',
            actionLink: {
              name: this.$enableNewDesign ? 'subbrandSetup' : 'createSubbrand',
              params: {
                isEdit: false,
                backLink: '/dataloader',
                backText: 'Back to Sub-brands List'
              }
            }
          }
        ]
      }
      return config
    },
    subBrandListData() {
      return this.$store.state.subbrandListStore.subBrandListData
    }
  },
  filters: {
    formatDate: function(value) {
      let today = new Date().toLocaleDateString()
      let lastPublished = new Date(value).toLocaleDateString()
      if (today == lastPublished) {
        return 'Today'
      } else {
        return new moment(String(value)).format('DD MMM YYYY')
      }
    },
    formatDateTime: function(value) {
      if (value) {
        return new moment(String(value)).format('hh:mm a')
      }
    }
  },
  methods: {
    isNewDesignEnabled() {
      return this.$enableNewDesign
    },
    showNewSetup() {
      this.$store.state.appStore.selectedSubbrandInfo = {}
      this.$router.push('subbrandSetup')
    },
    showReview(subbrandInfo) {
      this.dialog = false
      this.$store.state.appStore.selectedSubbrandInfo = subbrandInfo
      let reqObj = { id: subbrandInfo._id }

      this.getSubbrandinfo(
        subbrandInfo,
        this.routeToReviewSubrandSuccess,
        this.routeToEditSubrandFailure
      )
    },
    updatePagination(value) {
      if (value >= 1 && value <= this.pageCount) {
        this.page = parseInt(value)
      }
    },
    disableForApi(item) {
      if (
        item.config &&
        item.config.generalConfig &&
        item.config.generalConfig.customerType === 'API'
      ) {
        return true
      } else {
        return false
      }
    },
    updatedOnPublish(item) {
      return this.envMapping(item)
    },
    statusMap(item) {
      let status = item.status
      switch (status) {
        case 1:
          return {
            className: 'initiate-indicator',
            statusText: 'Publish initiated in Private'
          }
        case 2:
          return {
            className: 'initiate-indicator',
            statusText: 'Publish initiated in Public'
          }
        case 3:
          return {
            className: 'failed-indicator',
            statusText: 'Publish failed in Private'
          }
        case 4:
          return {
            className: 'failed-indicator',
            statusText: 'Publish failed in Public'
          }
        case 5:
          return {
            className: 'published-indicator',
            statusText: 'Published in Private'
          }
        case 6:
          return {
            className: 'published-indicator',
            statusText: 'Published in Public'
          }
        case 7:
          return {
            className: 'never-published-indicator',
            statusText: 'Never published'
          }
        default:
          return {}
      }
    },
    searchCol: function(val) {
      this.search = val
    },
    filterSubbrandName(value, search, item) {
      if (search.length <= 2) return item

      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toLowerCase().indexOf(search.toLowerCase()) !== -1
      )
    },
    confirmPublishModal(item) {
      this.publishedIndex = this.subBrandListData.indexOf(item)
      this.subrandModal = Object.assign({}, item)
      this.dialog = true
    },
    customizeApps(subbrandInfo) {
      this.$store.state.appStore.selectedSubbrandInfo = subbrandInfo
      this.$router.push('/customization')
    },
    loadOverview(subbrandInfo) {
      this.$store.state.appStore.selectedSubbrandInfo = subbrandInfo
      let reqObj = {
        subbrandId: subbrandInfo.cobrandId,
        event: 'PUBLISH_TO_PRODUCTION',
        publishStatus: 'COMPLETED'
      }

      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/audit/get',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          if (
            response.data &&
            response.data.data &&
            response.data.data.publishData
          ) {
            let subbrandConfigData = response.data.data.publishData.config
            subbrandConfigData.publishedOn =
              response.data.data.publishData.publishedOn
            subbrandConfigData.eventType = response.data.event

            this.$router.push({
              name: 'overview',
              params: {
                backLink: '/dataloader',
                backText: 'Back to Sub-brands List',
                subbrandConfigData: subbrandConfigData
              }
            })
          } else {
            reqObj = {
              subbrandId: subbrandInfo.cobrandId,
              event: 'PUBLISH_TO_DEVELOPMENT',
              publishStatus: 'COMPLETED'
            }

            serviceRegistery
              .makeCall({
                url: this.$hostname + 'services/audit/get',
                method: 'POST',
                data: reqObj
              })
              .then(response => {
                if (
                  response.data &&
                  response.data.data &&
                  response.data.data.publishData
                ) {
                  let subbrandConfigData = response.data.data.publishData.config
                  subbrandConfigData.publishedOn =
                    response.data.data.publishData.publishedOn
                  subbrandConfigData.eventType = response.data.event

                  this.$router.push({
                    name: 'overview',
                    params: {
                      backLink: '/dataloader',
                      backText: 'Back to Sub-brands List',
                      subbrandConfigData: subbrandConfigData
                    }
                  })
                } else {
                  console.log('No DATA')
                }
              })
              .catch(error => {
                this.showToastMessage(
                  'Sorry, a technical error has occurred! Please try again later.'
                )
              })
          }
        })
        .catch(error => {
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    routeToEditSubrandSuccess() {
      let publishedStatus = this.$store.state.appStore.selectedSubbrandInfo
        .status
      this.$router.push({
        name: 'editSubbrand',
        params: {
          backLink: '/dataloader',
          backText: 'Back to Sub-brands List',
          isDraft: publishedStatus === 7
        }
      })
    },
    routeToReviewSubrandSuccess() {
      this.$router.push({
        name: 'editSubbrand',
        params: {
          backLink: '/dataloader',
          backText: 'Back to Sub-brands List',
          stepperId: 5
        }
      })
    },
    routeToEditSubrandFailure() {
      console.log('No Data')
    },
    editSubrand(subbrandInfo) {
      this.$store.state.appStore.selectedSubbrandInfo = subbrandInfo
      this.getSubbrandinfo(
        subbrandInfo,
        this.routeToEditSubrandSuccess,
        this.routeToEditSubrandFailure
      )
    },
    editSubrandNew(subbrandInfo) {
      this.$store.state.appStore.selectedSubbrandInfo = subbrandInfo
      let reqObj = {
        id: subbrandInfo._id,
        includeConfig: true
      }
      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/get',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          if (response && response.data) {
            let subbrandConfigData = response.data.config
            this.$store.state.appStore.selectedSubbrandInfo = response.data

            // Mearge Response Data with template data
            // template Data
            var templateData = this.$store.state.createSubbrandStore
              .setupTemplateData
            var mergedData = _.merge(templateData, response.data)
            console.log('Mearged Data---->', mergedData)
            this.$store.state.createSubbrandStore.setupTemplateData = mergedData
            console.log(subbrandConfigData)
            this.$router.push({
              name: 'subbrandSetup',
              params: {
                backLink: '/dataloader',
                backText: 'Back to Sub-brands List',
                stepperId: 5
              }
            })
          } else {
            console.log('No Sub-brand Data')
          }
        })
        .catch(error => {
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    publish(item) {
      var _self = this,
        envState
      if (item.state == 1) {
        envState = 'DEVELOPMENT'
      } else if ((item.state == 2 && item.status == 5) || item.status == 4) {
        envState = 'PRODUCTION'
      }
      this.publishLoading = true
      let reqObj = { id: item._id, env: envState }

      serviceRegistery
        .makeCall({
          url: this.$hostname + 'services/subbrand/publish',
          method: 'POST',
          data: reqObj
        })
        .then(response => {
          if (response && response.data) {
            Object.assign(
              _self.subBrandListData[_self.publishedIndex],
              response.data
            )
            console.log('publish--->', response.data)
            this.dialog = false
            this.publishLoading = false
          }
        })
        .catch(error => {
          this.dialog = false
          this.publishLoading = false
          this.showToastMessage(
            'Sorry, a technical error has occurred! Please try again later.'
          )
        })
    },
    confirmDeleteModal(item) {
        this.publishedIndex = this.subBrandListData.indexOf(item)
        this.deleteSubrandModal = Object.assign({}, item)
        this.deleteDialog = true
    },
    deleteSubbrand(item) {
      var _self = this;
      this.deleteLoading = true
      let reqObj = {
            id: item._id
        }
      serviceRegistery
        .makeCall({
            url: _self.$hostname + 'services/subbrand/delete',
            method: 'POST',
            data: reqObj
        })
        .then(response => {
            if (response && response.data) {
                _self.deleteDialog = false
                _self.deleteLoading = false
                _self.subBrandListData.splice(_self.publishedIndex, 1)
                _self.$store.state.subbrandListStore.subBrandListData = _self.subBrandListData
                _self.$root.$emit('updateCount', _self.subBrandListData.length);
                _self.showToastMessage('Deleted successfully.')
                _self.$router.push('/list')
            }
        })
        .catch(error => {
            _self.deleteDialog = false
            _self.deleteLoading = false
            _self.showToastMessage('Sorry, a technical error has occurred! Please try again later.')
        })
    }
  }
}
</script>

<style lang="scss">
.v-application {
  .publish-popup {
    border-radius: 4px 4px 0px 0px;
    .v-card__title.headline {
      box-shadow: inset 0px -1px 0px #d6d6d6;
      background: #fafafa;
    }
    .headline {
      font-size: 18px !important;
      line-height: 22px;
      color: #383838;
      font-weight: 500;
    }
    .v-card__text {
      color: #383838 !important;
      font-size: 15px;
      padding-top: 24px !important;
    }
    .v-card__actions {
      padding: 0 24px 24px 24px;
    }
    .close-btn {
      background-color: transparent !important;
      color: #888888;
      padding: 0px;
      min-width: 16px;
      &:hover:before,
      &:focus:before,
      &:active:before,
      &:before {
        background-color: transparent !important;
      }
    }
  }
}
.v-overlay {
  opacity: 0.25;
  background-color: #000000;
}
#subbrandListCnr {
  display: flex;
  flex: 1 1 auto;
  .input-pages {
    display: inline-block;
    width: 32px !important;
    height: 22px !important;
    font-size: 14px;
    .v-input__slot {
      padding: 0 0 0 11px;
      min-height: 32px !important;
      background-color: #ffffff !important;
    }
    .v-text-field input {
      padding: 0;
    }
    input[type='number'] {
      -moz-appearance: textfield;
      color: #888888;
    }
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
      -webkit-appearance: none;
    }
  }
  .page-total {
    color: #888888;
    font-size: 14px;
    padding-left: 12px;
    display: inline-block;
    span:last-child {
      padding-left: 12px;
    }
  }
  .v-pagination__navigation:not(.v-pagination__navigation--disabled) i {
    color: #0070c9;
  }
  .search {
    &.v-text-field {
      width: 270px;
    }
    &.v-text-field .v-label {
      color: #888888 !important;
      top: calc(50% - 17px / 2 - 0.5px);
      height: 17px;
      line-height: 17px;
      font-size: 14px;
    }
    &.v-text-field input {
      line-height: 17px;
      padding: 15px 0 16px;
      margin-top: 0;
      max-height: none;
    }
    .v-input__slot {
      min-height: 48px;
      border-radius: 3px;
    }
    .v-input__prepend-inner,
    .v-input__append-inner {
      margin-top: 12px;
    }
  }
}

.status-msg {
  display: flex;
}
.v-btn:not(.v-btn--round).v-size--default {
  height: 32px;
  font-weight: normal;
}
.dot {
  height: 8px;
  width: 8px;
  margin-top: 5px;
  margin-right: 5px;
  border-radius: 50%;
  display: inline-block;
}
.never-published-indicator {
  background-color: #ffffff;
  border: 1px solid #888888;
  border-radius: 50%;
}
.initiate-indicator {
  background-color: #888888;
}
.failed-indicator {
  background-color: #dc3828;
}
.published-indicator {
  background-color: #20c040;
}
.search .v-icon {
  width: 16px;
  height: 16px;
  color: #888888 !important;
}
.publish-subbrand-name-text {
  word-break: break-all;
}
td.fail-message {
    display: flex;
    padding: 20px 10px !important;
    height: 87px;
    .v-btn.v-btn--disabled {
        min-width: auto !important;
        padding: 0 4px !important;
        .v-icon {
            color: #0070c9 !important
        }
    }
    > span {
        width: 402px;
    }
}
</style>
